<button mat-icon-button class="disabledWhite" *ngIf="!isFromActionList" [disabled]="selectionModel.selected.length === 0 || selectionModel.selected.length > 50" (click)="openEmailModal(selectionModel.selected)">
  <mat-icon>mail</mat-icon>
</button>

<button mat-menu-item class="disabledWhite" *ngIf="isFromActionList" [class.fromActionList]="isFromActionList" [disabled]="selectionModel.selected.length === 0 || selectionModel.selected.length > 50" (click)="openEmailModal(selectionModel.selected)">
  <mat-icon>mail_outline</mat-icon>
  <span>Envoyer par email</span>
</button>
